import {
  Component, Output,
  Input, OnInit, ViewEncapsulation, inject, ViewChild, ViewContainerRef, ChangeDetectorRef,
  viewChild,
  ChangeDetectionStrategy,
  TemplateRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID, GridSize } from '@progress/kendo-angular-grid';
import { IconsModule, KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { Subject, Subscription } from 'rxjs';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule } from '@progress/kendo-angular-inputs';

import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';

import { CellDefaultStyle, KENDO_SPREADSHEET, SheetDescriptor, SheetRow, SpreadsheetBackColorComponent, SpreadsheetComponent, SpreadsheetExcelExportEvent, SpreadsheetForeColorComponent, SpreadsheetMainMenuItem } from "@progress/kendo-angular-spreadsheet";
import { DialogRef, DialogService, DialogsModule } from '@progress/kendo-angular-dialog';
import { SVGIcon, fileExcelIcon, minusIcon, plusIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { Users, AccessTypeItem, Objects, AccesObjects, emptyAccessObjects, OrderUserValidationDTO, emptyObjects, CopyUserAccess, emptyCopyUserAccess, emptyUsers } from '../../../_models/admin';
import { PortalAdminService } from '../../../_services/portal-admin.service';
import { MsalService } from '@azure/msal-angular';
import {
  KENDO_NOTIFICATION,
  NotificationRef,
  NotificationService,
  NotificationSettings,
} from "@progress/kendo-angular-notification";
import { TreeItem, TreeViewModule } from '@progress/kendo-angular-treeview';
import { TreeListItem, ExpandEvent, TreeListComponent, TreeListModule, FlatBindingDirective, SelectableSettings, SelectionItem, ColumnBase, ExcelExportEvent, ExcelComponent, ExcelModule } from '@progress/kendo-angular-treelist';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { saveAs } from '@progress/kendo-file-saver';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-access',
  imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION, KENDO_DROPDOWNS, KENDO_SPREADSHEET, IconsModule,
    DialogsModule, TreeViewModule, TreeListModule, ContextMenuModule,
    LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule, ReactiveFormsModule, ExcelComponent, ExcelModule
  ],
  templateUrl: './access.component.html',
  styleUrl: './access.component.css',
  encapsulation: ViewEncapsulation.None
})
export class AccessComponent {
  portalAdminService = inject(PortalAdminService);
  //private expandedIds: number[] = [1, 2, 3];
  accessObjects: AccesObjects[] = [];
  access: AccesObjects[] = [];
  displayObjects: AccesObjects[] = [];
  adminObjects: Objects[] = [];
  public selected: SelectionItem[] = [];
  accessObject: AccesObjects = emptyAccessObjects();
  selectedAccessObject: AccesObjects = emptyAccessObjects();
  loading: boolean = false;
  width = '200';
  usersWidth = '200';
  public settings: SelectableSettings = {
    enabled: true,
    mode: "row",
    multiple: false,
    drag: true,
    readonly: false
  };
  excelSVG: SVGIcon = fileExcelIcon;
  subscription: Subscription[] = [];
  adminUsers: Users[] = [];
  displayUsers: Users[] = [];
  initialUsers: Users[] = [];
  selectedProjectId: number = -1;
  loadingones: boolean = true;
  openedaccesswindow: boolean = false;
  addbutton: boolean = false;
  private _project: any;
  @Input()
  set project(value: any) {
    this._project = value;

    if (value) {
      console.log('Project:', value);
    }
  }

  get project(): any {
    return this._project;
  }

  accesssavebutton: boolean = true;
  show = false;
  addUserToMultipleOrder: boolean = false;
  showConflictPopup: boolean = false;
  showCopyAccessDialog: boolean = false;
  conflictingUsers: OrderUserValidationDTO[] = [];
  copyConflictingUsers: OrderUserValidationDTO[] = [];
  showConfirmDialog: boolean = false;
  showCopyConflictPopup: boolean = false;
  auto = 'auto';
  private expansionToken: string | null = null;
  accessItems: Array<AccessTypeItem> = [
    { text: "View", value: 4 },
    { text: "Upload", value: 5 },

    { text: "Process", value: 3 },
    { text: "Remove", value: 6 },
    // { text: "Admin", value: 1 },
  ];
  

  allAccessItems: Array<AccessTypeItem> = [
    { text: "View", value: 4 },
    { text: "Upload", value: 5 },

    { text: "Process", value: 3 },
    // { text: "Admin", value: 1 },
  ];

  uiAccessItems: Array<AccessTypeItem> = [...this.allAccessItems];

  @ViewChild('userExistsDialog', { static: false }) userExistsDialog!: TemplateRef<any>;
  @ViewChild('companyDifferentDialougue', { static: false }) companyDifferentDialougue!: TemplateRef<any>;
  

  warningGridData: { order: string; email: string; access: string }[] = [];

  accessSelectedItem: AccessTypeItem = this.uiAccessItems[0];
  newUserAdded: boolean = false;
  userUpdated: boolean = false;
  cellHeight: any;
  lastUserAddedToObject: any;
  lastAddedUser: any;
  lastAddedAccessId: number = 0;
  expandedIds: any[] = [];
  allExpandableIds: any[] = [];
  //openUploadWindow: boolean = false;
  errorWindow = false;
  title = '';
  content = '';
  cleanedWarning = '';
  secondSearch = '';
  firstSearch = '';
  errorMsg = '';
  selectedTargetUserId: number = -1;
  sourceUserId: number  = -1;
  searching = false;
  
  copyAllUsers: Users[] = [];
  copyDisplayUsers: Users[] = [];
  copyAccessReq: CopyUserAccess = emptyCopyUserAccess();
  userObjValidate: Users | undefined = emptyUsers();

  private dialogAllUsers: Users[] = [];
  public iconNames: SVGIcon[] = [plusIcon, minusIcon, uploadIcon];
  private targetIdToFocus: number | string | null = null;
  
  @ViewChild('treelist') treelist!: TreeListComponent;
  @ViewChild('dialogContent', { static: true }) dialogContentTemplate!: TemplateRef<any>;

  constructor(private cdr: ChangeDetectorRef, private notificationService: NotificationService, private dialogService: DialogService, private sanitizer: DomSanitizer,) {

  }

  ngOnInit(): void {
    this.loadingones = true;
    this.subscription.push(
      this.portalAdminService.projectSubject.subscribe({
        next: (data) => {
          if (data != null && this.selectedProjectId != data.projectId!) {
            this.selectedProjectId = data.projectId!;
            this.cdr.markForCheck();
            this.handleLoad(data.projectId!);
          }
        },
        error: (error) => {
          this.showError(JSON.stringify(error.message));
          console.log(error);
        },
        complete: () => {
          console.log('completed ');
        },
      }),
    );
    if (this.project?.projectId != null && this.selectedProjectId != this.project?.projectId!) {
      this.selectedProjectId = this.project?.projectId!;
      this.cdr.markForCheck();
      this.handleLoad(this.project?.projectId!);
    }
    this.contextmenu[0].disabled = true;
    this.contextmenu[1].disabled = true;
    this.contextmenu[2].disabled = true;
    this.newUserAdded = false;
    this.userUpdated = false;
  }

  
  getObjectsAccess(projectid: number) {

    this.portalAdminService.getObjectsAccess(projectid).subscribe({
      next: (result) => {
        this.access = result;
        this.cdr.markForCheck();
        console.log(" this.access", this.access)
      },
      error: (error) => {
        //throw message of some sort
        this.showError(JSON.stringify(error.message));
        console.log(error)
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        const parentIds = new Set<any>();
        for (let index = 0; index < this.access.length; ++index) {
          this.accessObject = emptyAccessObjects();
          this.accessObject.name = this.access[index].firstname + ' ' + this.access[index].lastname;
          this.accessObject.description = this.access[index].email;
          this.accessObject.objectId = this.access[index].objectId;
          this.accessObject.accessName = this.access[index].accessName;
          this.accessObject.accesId = this.access[index].accesId;
          this.accessObject.email = this.access[index].email;
          this.accessObject.enabled = this.access[index].enabled;
          this.accessObject.userId = this.access[index].userId;
          this.accessObject.userType = this.access[index].userType;

          let x = this.access[index].id;
          let y = this.access[index].objectId!;
          /*100000 used for making the id Unque*/
          this.accessObject.id = x + 100000;

          if (this.accessObject.objectId !== null) {
            parentIds.add(this.accessObject.objectId);
          }
          this.accessObjects.push(this.accessObject);
        }
        this.allExpandableIds = Array.from(parentIds);
        this.expandedIds = [...this.allExpandableIds];

        this.displayObjects = this.accessObjects;
        console.log("this.displayObjects-->", this.displayObjects, this.lastUserAddedToObject, this.lastAddedUser, this.accessObjects)
        this.cdr.markForCheck();
        if (this.newUserAdded || this.userUpdated) {
          const foundObject = this.accessObjects.find(o => o.objectId == this.lastUserAddedToObject && o.email.toLowerCase() == this.lastAddedUser.toLowerCase())!;
          if (foundObject) {

            this.selectedAccessObject = foundObject;

            if (foundObject.objectId !== null && foundObject.objectId !== undefined) {
              this.selectedObjectId = foundObject.objectId;
            }

            this.accessSelectedItem = this.uiAccessItems.find(a => a.value === foundObject.accesId)!;
            this.selected = [{ itemKey: foundObject.id }]; 

          }
          /*this.accessSelectedItem = this.accessItems.find(a => a.value == this.selectedAccessObject.accesId)!;
          this.selected = [
            { itemKey: this.selectedAccessObject.id }
          ]*/
        }

        //        console.log('displayObjects ' + JSON.stringify(this.displayObjects));
      }
    });
  }

  public rowCallback = (context: { dataItem: any, index: number }) => {
    //return context.dataItem.enabled === 'F' ? 'disabled-row' : '';
    //console.log("dataItem",context.dataItem)
    const isDisabled = context.dataItem.enabled === 'F';
    const isTarget   = this.targetIdToFocus != null && context.dataItem.id === this.targetIdToFocus;

    return {
      'disabled-row': isDisabled,     // existing behavior
      'added-target-row': isTarget    // only during addUser
    };

  };

  public rowCallbackAddUser = (context: { dataItem: any}) => {
    //return context.dataItem.enabled === 'F' ? 'disabled-row' : '';
    //console.log("dataItem",context.dataItem)
    const isDisabled = context.dataItem.enabled === 'F';
    //const isTarget   = this.targetIdToFocus != null && context.dataItem.id === this.targetIdToFocus;

    return {
      'disabled-row': isDisabled     // existing behavior
      //'added-target-row': isTarget    // only during addUser
    };

  };


  ngAfterViewChecked() {
    if ((this.newUserAdded || this.userUpdated) && this.treelist.view.length > 0 && this.selectedAccessObject?.id) {
      console.log("selectedAccessObject===", this.selectedAccessObject)
      const rowIndex = this.treelist.view.findIndex((r: any) => r.data.id == this.selectedAccessObject.id);
      console.log("rowIndex", rowIndex, this.treelist.view);
      this.scrollTo(rowIndex - 1);
      /*if(this.userUpdated){
        this.scrollTo(rowIndex);
      }else{
        this.scrollTo(rowIndex - 1);
      }*/


    }
  }

  public scrollTo(rowIndex: number) {
    var container = document.getElementsByClassName("k-grid-content");
    this.newUserAdded = false;
    this.userUpdated = false;
    this.lastAddedUser = null;
    this.lastUserAddedToObject = null;
    console.log("this.cellHeight", this.cellHeight)
    container[0].scrollTo({
      top: rowIndex * this.cellHeight!,
      behavior: "smooth",
    });
  }

  handleLoad(projectid: number) {
    this.loadingones = true;
    this.access = [];
    this.adminObjects = [];
    this.displayObjects = [];
    this.accessObject = emptyAccessObjects();
    this.accessObjects = [];
    this.selectedProjectId = projectid;
    this.getAdminObjects(projectid);

  }

  getAdminObjects(projectid: number) {
    this.loading = true;
    //this.adminObjects = [];

    this.portalAdminService.getObjects(projectid).subscribe({
      next: (result) => {
        this.adminObjects = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
        for (let index = 0; index < this.adminObjects.length; ++index) {
          this.accessObject = emptyAccessObjects();
          this.accessObject.name = this.adminObjects[index].name + ' ' + this.adminObjects[index].description;
          this.accessObject.id = this.adminObjects[index].id!;
          this.accessObjects.push(this.accessObject);
        }
        this.getObjectsAccess(projectid);
      }
    });
  }


  public isSelected(dataItem: any, column?: ColumnBase, columnIndex?: number) {
    return dataItem.type === "directory";
  }

  cellClickHandler(event: any) {

  }

  selectedObjectId!: number;
  selectedUserId!: number;
  selectedAccessId!: number;
  descriptionLabel: string = '';
  selectionChange(event: any) {
    this.show = true;
    const selectedItem = event.selectedRows?.[0]?.dataItem;
    if (selectedItem?.enabled === 'F') {
      // Prevent selection
      event.preventDefault?.();
      return;
    }
    console.log("event.items[0].dataItem",event.items[0].dataItem)
    this.selectedAccessObject = emptyAccessObjects();
    this.contextmenu[0].disabled = false;
    if (event.items[0].dataItem.objectId != null) {
      this.selectedObjectId = event.items[0].dataItem.objectId;
      if(event.items[0].dataItem.userType =='S' || event.items[0].dataItem.userType =='X'){
        this.contextmenu[1].disabled = false;
        this.contextmenu[2].disabled = true;
        this.contextmenu[3].disabled = true;
        this.contextmenu[4].disabled = false;
        this.contextmenu[5].disabled = true;
      }else{
        this.contextmenu[1].disabled = false;
        this.contextmenu[2].disabled = false;
        this.contextmenu[3].disabled = false;
        this.contextmenu[4].disabled = false;
        this.contextmenu[5].disabled = false;
      }
      
      
      
    } else {
      this.selectedObjectId = event.items[0].dataItem.id;
      console.log("2")
      this.contextmenu[1].disabled = true;
      this.contextmenu[2].disabled = true;
      this.contextmenu[4].disabled = true;
      this.contextmenu[5].disabled = true;
    }
    this.selectedAccessObject.objectId = this.selectedObjectId;
    this.selectedAccessObject.id = event.items[0].dataItem.id;
    this.selectedAccessObject.email = event.items[0].dataItem.description;
    this.selectedAccessObject.description = event.items[0].dataItem.description;
    this.selectedAccessObject.name = event.items[0].dataItem.name;
    this.selectedAccessObject.userId = event.items[0].dataItem.userId;
    if(event.items[0].dataItem.accesId == null){
      this.selectedAccessObject.accesId = this.uiAccessItems[0].value;
    }else{
      this.selectedAccessObject.accesId = event.items[0].dataItem.accesId;
    }
    
    console.log("this.selectedAccessObject--in selection change",this.selectedAccessObject)
    
    for (var i = 0; i < this.uiAccessItems.length; i++) {
      if (this.uiAccessItems[i].value == event.items[0].dataItem.accesId) {

        this.accessSelectedItem = this.uiAccessItems[i];
        console.log("this.accessSelectedItem---->",this.accessSelectedItem)
        break;
      }

    }
  }

  contextmenu: any[] = [
    {
      id: 1,
      text: 'Add User',
      disabled: false,
    },
    {
      id: 2,
      text: 'Remove User',
      disabled: false
    },
    {
      id: 3,
      text: 'Change Right',
      disabled: false
    },
    {
      id: 4,
      text: 'Add User To All Orders',
      disabled: false
    },
    {
      id: 5,
      text: 'Remove User From All Orders',
      disabled: false
    },
    {
      id: 6,
      text: 'Copy User Access To Other User',
      disabled: false
    },

  ];
  changedAccessId: number = -1;
  contextSelect(event: any, element: any) {
    this.uiAccessItems = [...this.allAccessItems];
    if (event.item.text === 'Add User') {
      this.openeduserswindow = true;
      this.show = false;
      this.addUserToMultipleOrder = false;
      this.selection = [];
      this.addbutton = true;
      this.accessSelectedItem = this.uiAccessItems[0];
      console.log("this.accessSelectedItem", this.accessSelectedItem)
      this.selectedAccessObject.accesId = 4;
      this.selectedAccessObject.id != null;
      if (this.initialUsers.length != 0) {
        this.displayUsers = this.initialUsers;
        console.log(this.initialUsers.length);
      }
      if (this.displayUsers.length == 0) {
        this.getAdminUsers();
      }

    }
    if (event.item.text === 'Remove User') {
      this.removeUser();

    }

    if (event.item.text === 'Change Right') {
      this.selection = [];
      this.openedaccesswindow = true;
      this.changedAccessId = this.selectedAccessObject.accesId!;
    }

    if (event.item.text === 'Add User To All Orders') {
      this.openeduserswindow = true;
      this.show = false;
      this.addUserToMultipleOrder = true;
      this.selection = [];
      this.addbutton = false;
      this.accessSelectedItem = this.uiAccessItems[0];
      this.selectedAccessObject.accesId = 4;
      this.selectedAccessObject.id != null;
      if (this.initialUsers.length != 0) {
        this.displayUsers = this.initialUsers;
        console.log(this.initialUsers.length);
      }
      if (this.displayUsers.length == 0) {
        this.getAdminUsers();
      }

    }

    if (event.item.text === 'Remove User From All Orders') {
      this.showConfirmDialog = true;
      this.cdr.markForCheck();
    }

  
    if (event.item.text === 'Copy User Access To Other User') {
      
      this.selectedTargetUserId = -1;
      this.showCopyAccessDialog = true;

      // Decide the identity to exclude (keep consistent with valueField="id")
      this.sourceUserId = Number(this.selectedAccessObject?.userId ?? this.selectedAccessObject?.id);

      if (this.displayUsers.length === 0) {
        // First time → call getAdminUsers and then WAIT (without changing getAdminUsers)
        this.getAdminUsers();

        // Wait until displayUsers gets populated, then snapshot and exclude
        this.waitUntilUsersLoaded()
          .then(() => {
            const src = Number(this.sourceUserId);

            // Take snapshot AFTER load
            this.dialogAllUsers = (this.displayUsers || []).slice();

            // Exclude source for initial view
            
            this.displayUsers = this.dialogAllUsers
                      .filter(u => Number(u.id) !== src)
                      .sort(this.sortByNameAsc); 


            this.cdr.markForCheck();
          })
          .catch(err => {
            console.error(err);
            // Optionally show an error toast/message
          });

      } else {
        // Already have users → snapshot now, exclude source
        const src = Number(this.sourceUserId);
        this.dialogAllUsers = (this.displayUsers || []).slice();
        
        this.displayUsers = this.dialogAllUsers
              .filter(u => Number(u.id) !== src)
              .sort(this.sortByNameAsc);      

        this.cdr.markForCheck();
      }
    }
  }

  /** Wait until `displayUsers` is populated (or timeout). */
  private waitUntilUsersLoaded(maxWaitMs = 5000, pollMs = 100): Promise<void> {
    const start = Date.now();
    return new Promise((resolve, reject) => {
      const check = () => {
        if (Array.isArray(this.displayUsers) && this.displayUsers.length > 0) {
          resolve();
          return;
        }
        if (Date.now() - start > maxWaitMs) {
          reject(new Error('Timed out waiting for users to load.'));
          return;
        }
        setTimeout(check, pollMs);
      };
      check();
    });
  }

  // Case-insensitive, locale-aware comparator; handles null/empty names
  private sortByNameAsc = (a: Users, b: Users) => {
    const an = (a.name || '').trim();
    const bn = (b.name || '').trim();
    if (!an && !bn) return 0;
    if (!an) return 1;  // push empties to the bottom
    if (!bn) return -1;
    return an.localeCompare(bn, undefined, { sensitivity: 'base' });
  };


  usersLoading: boolean = false;
  selection: any[] = [];
  selectedRowItem: any[] = [];
  openeduserswindow: boolean = false;
  smallSize: GridSize = 'small';
  pageSize: number = 30;
  getAdminUsers(callback?: () => void) {
    this.usersLoading = true;
    this.adminUsers = [];

    this.portalAdminService.getUsers().subscribe({
      next: (result) => {
        this.adminUsers = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.usersLoading = false;
      },
      complete: () => {
        this.displayUsers = this.adminUsers;
        this.initialUsers = this.displayUsers;
        this.usersLoading = false;

        for (const u of this.displayUsers) {
          const fname = (u.firstname || '').trim();
          const lname = (u.lastname || '').trim();
          u.name = (fname + ' ' + lname).trim() || (u.name || '').trim() || (u.email || '').trim();
        }
      }
    });
  }

  closeUsersWindow() {
    this.show = true;
    this.openeduserswindow = false;
  }

  addUser() {
    console.log("this.selectedAccessObject",this.selectedAccessObject)
    this.show = true;
    this.addbutton = true;
    this.selectedAccessObject.email = this.selection[0];
    this.lastUserAddedToObject = this.selectedAccessObject.objectId;
    this.lastAddedUser = this.selection[0];
    this.lastAddedAccessId = this.selectedAccessObject.accesId ?? 0;
    this.cellHeight = document.querySelector(".k-table-td")?.clientHeight;
    

    const targetId = this.selectedAccessObject.id ?? this.selectedAccessObject.objectId ?? null;
    this.targetIdToFocus = targetId;
    const path = targetId ? this.buildExpansionPath(targetId) : null;
    console.log("this.pendingPath",path)

    
    const token = `expand-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    this.expansionToken = token;

    console.log("this.selectedAccessObject",this.selectedAccessObject)

    
    
    const selectedUser = this.adminUsers?.find(u => u.email.trim().toLowerCase() === this.selection[0].trim().toLowerCase());

    const userCompany = selectedUser?.companyName;

    const targetObject = this.adminObjects.find(
      obj => obj.id === this.selectedAccessObject.objectId
    );

    const objectCompany = targetObject?.companyName;

    console.log("userCompany",userCompany,"objectCompany",objectCompany)
    /*if (
      userCompany &&
      objectCompany &&
      userCompany !== objectCompany
    ) {
      const message = `Warning: User Company (${this.lastAddedUser} - ${userCompany}) is not associated with Order (${targetObject?.name} - ${objectCompany}). 
  Do you wish to continue adding User to Order?`;

      const confirmAdd = window.confirm(message);

      if (!confirmAdd) {
        this.addbutton = false;
        return; // Stop execution if user selects "No"
      }
    }*/
   if (
      userCompany &&
      objectCompany &&
      userCompany !== objectCompany && (selectedUser.usertype == 'S' || selectedUser.usertype == 'X')
    ) {

      
      const accessText =
        this.allAccessItems.find(
          x => x.value === this.selectedAccessObject.accesId
        )?.text ?? '';

      this.diffCompanyWarningGridData = [{
        order: targetObject?.name,
        email: this.lastAddedUser,
        access: accessText
      }];

      const dialog: DialogRef = this.dialogService.open({
        title: 'Company Mismatch Warning',
        content: this.companyDifferentDialougue, // SAME template you already use
        actions: [
          { text: 'Cancel' },
          { text: 'Continue', themeColor: 'primary' }
        ],
        width: 550,
        height: 350
      });

      dialog.result.subscribe((result: any) => {

        if (result.text === 'Cancel') {
          this.addbutton = false;
          return;
        }

        if (result.text === 'Continue') {
          this.handleUser();
          this.tryApplyExpansion(path, token);
        }
      });

      return; // STOP normal flow
    }

    this.handleUser();
    this.tryApplyExpansion(path, token);

  }


  tryApplyExpansion(path: Array<string | number> | null,token: string,attempt = 0) {
    if (!path || !this.expansionToken || this.expansionToken !== token) {
      return; 
    }
    if (attempt > 50) { // ~5s max at 100ms
      this.expansionToken = null;
      this.targetIdToFocus = null;
      return;
    }

    const isReady =!this.loading && Array.isArray(this.displayObjects) && this.displayObjects.length > 0;

    if (isReady) {
      this.expandedIds = [...path];
      this.cdr.markForCheck();
      
      requestAnimationFrame(() => {
          const treelistRoot =
            document.querySelector('.k-treelist') ||
            document.querySelector('.k-grid') ||
            document.body;

          const toolbarInput = treelistRoot?.querySelector('.k-textbox input') as HTMLInputElement | null;
          toolbarInput?.blur(); // avoid toolbar stealing focus

          const row = treelistRoot?.querySelector('tr.added-target-row') as HTMLElement | null;
          if (row) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            row.setAttribute('tabindex', '-1');
            row.focus();
          }

          this.expansionToken = null;
          this.targetIdToFocus = null;
       });
      return;
    }

    setTimeout(() => this.tryApplyExpansion(path, token, attempt + 1), 1000);
  }
  
  private buildExpansionPath(targetId: string | number): Array<string | number> {
    const parentMap = new Map(
      this.displayObjects.map(o => [o.id, o.objectId ?? null])
    );

    const path: Array<string | number> = [];
    let current: any = targetId;

    while (current != null) {
      path.push(current);
      current = parentMap.get(current) ?? null;
    }
    return path.reverse(); // root → ... → target
  }


  handleUser() {
    this.loading = true;
    if (this.addUserToMultipleOrder) {
      this.conflictingUsers = [];
      this.portalAdminService.validateUserAccess(this.selectedProjectId, this.selectedAccessObject).subscribe({
        next: (validationResult) => {

          if (validationResult?.length > 0) {
            this.conflictingUsers = validationResult;
            this.showConflictPopup = true;
            this.cdr.markForCheck();
          } else {
            this.addUserToAllOrders();
          }

        },
        error: (error) => {
          console.error(error);
          this.showError("Validation failed: " + error.message);
          this.loading = false;
        }
      });

    } else {
      console.log("this.selectedProjectId, this.selectedAccessObject",this.selectedProjectId, this.selectedAccessObject)
      this.portalAdminService.addObjectAccess(this.selectedProjectId, this.selectedAccessObject).subscribe({
        next: (result) => {
          this.selectedAccessObject = result;
          this.newUserAdded = true;
          this.selectedAccessId = this.selectedAccessObject.accesId ?? 0;
          this.cdr.markForCheck();

        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
          this.showError(JSON.stringify(error.message));
          this.loading = false;
        },
        complete: () => {

          this.loading = false;
          this.handleLoad(this.selectedProjectId);

          this.openeduserswindow = true;
          this.selected = [];

        }
      });
    }

  }

  onContinueConflict() {
    this.showConflictPopup = false;
    this.addUserToAllOrders();
  }

  onCancelConflict() {
    this.showConflictPopup = false;
    //this.openeduserswindow = false;
    this.loading = false;
    this.addbutton = false;
    this.cdr.markForCheck();
  }

  onOverride() {
    this.portalAdminService.overrideAndAddObjectAccessToAllOrders(this.selectedProjectId, this.selectedAccessObject).subscribe({
      next: (result) => {
        this.selectedAccessObject = result;
        this.newUserAdded = true;
        this.cdr.markForCheck();

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);

        this.showConflictPopup = false;
        this.openeduserswindow = true;
        this.selected = [];

      }
    });
  }


  addUserToAllOrders() {
    this.portalAdminService.addObjectAccessToAllOrders(this.selectedProjectId, this.selectedAccessObject).subscribe({
      next: (result) => {
        this.selectedAccessObject = result;
        this.newUserAdded = true;
        this.cdr.markForCheck();

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);

        this.showConflictPopup = false;
        this.openeduserswindow = true;
        this.selected = [];

      }
    });
  }

  updateUser() {
    this.loading = true;
    /*100000 used for making the id Unque*/
    let x = this.selectedAccessObject.id - 100000;
    this.selectedAccessObject.id = x;

    this.portalAdminService.updateObjectAccess(this.selectedProjectId, x, this.selectedAccessObject).subscribe({
      next: (result) => {
        this.selectedAccessObject = result;
        this.selectedAccessObject.id = x + 100000;
        this.selectedAccessObject.email = this.selection[0];
        this.lastUserAddedToObject = this.selectedAccessObject.objectId;
        this.userUpdated = true;
        this.cellHeight = document.querySelector(".k-table-td")?.clientHeight;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);

        this.openedaccesswindow = false;
        this.selected = [];
        this.accesssavebutton = true;


      }
    });
  }

  removeAccessOfUserFromOrderExcel(obj:any) {
    console.log("this.selectedAccessObject", this.selectedAccessObject)
    
    /*100000 used for making the id Unque*/
    let x = obj.id - 100000;//- this.selectedAccessObject.objectId!;
    this.portalAdminService.deleteObjectAccess(this.selectedProjectId, x).subscribe({
      next: (result) => {

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);


      }
    });
  }

  

/** Expand only the branch of the parent, collapse everything else */
private expandOnlyParentBranch(parentId: number | string | null, attempt = 0): void {
  if (attempt > 50) return; // ~5s guard
  if (parentId == null) {
    this.expandedIds = [];     // nothing to expand → collapse all
    this.cdr.markForCheck();
    return;
  }

  const ready =
    !this.loading &&
    Array.isArray(this.displayObjects) &&
    this.displayObjects.length > 0;

  if (!ready) {
    setTimeout(() => this.expandOnlyParentBranch(parentId, attempt + 1), 80);
    return;
  }

  // Lookups
  const ids = new Set(this.displayObjects.map(o => o.id));
  const parentMap = new Map(this.displayObjects.map(o => [o.id, o.objectId ?? null]));

  // If parent doesn't exist (rare), climb up to nearest ancestor
  let focusId: any = parentId;
  let guard = 0;
  while (focusId != null && !ids.has(focusId) && guard++ < 20) {
    focusId = parentMap.get(focusId) ?? null;
  }

  if (focusId == null) {
    this.expandedIds = [];
    this.cdr.markForCheck();
    return;
  }

  // Build expansion path (root → … → focusId)
  const path = this.buildExpansionPath(focusId);

  // 🔑 CRITICAL: Replace expansion with ONLY this path
  this.expandedIds = [...path];

  // Optional: focus the row
  this.targetIdToFocus = focusId;
  this.cdr.markForCheck();

  // Scroll/focus the row after rendering
  requestAnimationFrame(() => {
    const row = document.querySelector('tr.added-target-row') as HTMLElement | null;
    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      row.setAttribute('tabindex', '-1');
      row.focus();
    }
  });
}



  removeUser() {
    console.log("this.selectedAccessObject", this.selectedAccessObject)

    
    
  // The parent branch we want to expand after deletion
    const parentId = this.selectedAccessObject.objectId ?? null;

    // Tell the UI we’re loading (helper waits for !loading + data present)
    this.loading = true;


    
    /*100000 used for making the id Unque*/
    let x = this.selectedAccessObject.id - 100000;//- this.selectedAccessObject.objectId!;
    this.portalAdminService.deleteObjectAccess(this.selectedProjectId, x).subscribe({
      next: (result) => {

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);

        this.expandOnlyParentBranch(parentId);
      }
    });
  }

  removeUserAssignmentFromAllOrders() {
    this.showConfirmDialog = false;
    this.loading = true;
    this.selectedAccessObject.description
    /*100000 used for making the id Unque*/
    let x = this.selectedAccessObject.id - 100000;//- this.selectedAccessObject.objectId!;
    this.portalAdminService.deleteUserFromAllOrders(this.selectedProjectId, this.selectedAccessObject).subscribe({
      next: (result) => {

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);


      }
    });
  }

  onCancelRemove() {
    this.showConfirmDialog = false;
  }

  onConfirmRemove() {
    this.removeUserAssignmentFromAllOrders();
  }

  onUserCellClick(event: any) {
    if (event.originalEvent && event.originalEvent.button === 2) {
      return;
    }
    if(this.addUserToMultipleOrder){
      this.addbutton = false;
    }else{
      this.addbutton = true;
    }
    
    this.show = false;
    for (var i = 0; i < this.accessObjects.length; i++) {
      if (this.accessObjects[i].objectId == this.selectedObjectId) {
        if (this.accessObjects[i].email.trim().toLowerCase() === event.dataItem.email.trim().toLowerCase()) {
          console.log("this.accessObjects[i]",this.accessObjects[i])
          break;
        }
      }
    }
    console.log("i", i,"this.accessObjects",this.accessObjects.length,this.selectedObjectId)
    if (i == this.accessObjects.length && !this.addUserToMultipleOrder) {
      console.log("i", i,"this.accessObjects",this.accessObjects.length)
      this.addbutton = false;
    }

    
    const selectedUser = event.dataItem;
    console.log("selectedUser",selectedUser)
    if(selectedUser.enabled === 'F'){
      this.addbutton = true;
    }

    if (selectedUser.usertype === 'S' || selectedUser.usertype === 'X') {
      this.uiAccessItems = this.allAccessItems.filter(
        item => item.text === 'Upload'
      );
      console.log("this.uiAccessItems",this.uiAccessItems,this.uiAccessItems[1])
      this.selectedAccessObject.accesId = 5;
      this.accessSelectedItem =  this.uiAccessItems[0];
      
    } else {
      if(this.lastAddedAccessId!=0){
        this.selectedAccessObject.accesId = this.lastAddedAccessId;
        this.uiAccessItems = this.allAccessItems.filter(
          item => item.value === this.lastAddedAccessId
        );
        this.accessSelectedItem =  this.uiAccessItems[0];
      }else{
        this.selectedAccessObject.accesId = 4;
        this.accessSelectedItem =  this.uiAccessItems[0];
      }
      
      this.uiAccessItems = [...this.allAccessItems];
    }
    //this.accessSelectedItem = this.uiAccessItems[0];
   

  }

  closeAccessWindow() {
    this.openedaccesswindow = false;
  }



  onCancelCopy(){
    this.showCopyConflictPopup = false;
  }
  onOverrideCopy(){
     this.portalAdminService.copyUserAccessOfUserToAnotherUserAndOverrideExisting(this.copyAccessReq).subscribe({
      next: (result) => {
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);
        this.showCopyConflictPopup = false;
        this.showCopyAccessDialog = false;
        this.cdr.markForCheck();
        

      }
    });

  }
  onContinueCopyConflict(){
    //Without Overriding the existing ones
    this.portalAdminService.copyUserAccessOfUserToAnotherUser(this.copyAccessReq).subscribe({
      next: (result) => {
       
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);
        this.showCopyConflictPopup = false;
        this.showCopyAccessDialog = false;
        this.cdr.markForCheck();
        

      }
    });

  }
  onCancel(){
    this.showCopyAccessDialog = false;
  }
  onCopy(){
    console.log("selectedTargetUserId",this.selectedTargetUserId,this.selectedProjectId,this.sourceUserId)
    this.copyAccessReq.projectId = this.selectedProjectId;
    this.copyAccessReq.fromUserId = this.sourceUserId;
    this.copyAccessReq.toUserId = this.selectedTargetUserId;

    this.copyConflictingUsers = [];
    this.loading = true;
    this.portalAdminService.validateUserAccessToCopy(this.copyAccessReq).subscribe({
      next: (result) => {
       
        if (result?.length > 0) {
          this.copyConflictingUsers = result;
          this.showCopyConflictPopup = true;
          this.showCopyAccessDialog = false;
          this.cdr.markForCheck();
        } else {
          this.showCopyAccessDialog = true;
          this.showCopyConflictPopup = false;
          this.onOverrideCopy();
        }
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        //this.handleLoad(this.selectedProjectId);
        //this.showCopyAccessDialog = false;
        this.cdr.markForCheck();
        

      }
    });
  }

 onFilterChange(term: string): void {
  const t = (term || '').toLowerCase();
  const src = Number(this.sourceUserId);

  // Minimal change: if snapshot is empty (first time), fall back to current displayUsers
  const base = (this.dialogAllUsers && this.dialogAllUsers.length
    ? this.dialogAllUsers
    : (this.displayUsers || [])
  );

  if (!t) {
    // Reset to base, still excluding the source
    
    this.displayUsers = base
          .filter(u => Number(u.id) !== src)
          .sort(this.sortByNameAsc); 

    return;
  }

  // Multi-field search on the base; always exclude the source
  this.displayUsers = base.filter(u => {
    if (Number(u.id) === src) return false;
    const name = (u.name || '').toLowerCase();
    const fn   = (u.firstname || '').toLowerCase();
    const ln   = (u.lastname || '').toLowerCase();
    const em   = (u.email || '').toLowerCase();
    return name.includes(t) || fn.includes(t) || ln.includes(t) || em.includes(t);
  }).sort(this.sortByNameAsc);
}

  saveAccess() {
    this.openedaccesswindow = false;
    this.selectedAccessObject.accesId = this.changedAccessId;
    this.lastUserAddedToObject = this.selectedAccessObject.objectId;
    const foundObject = this.accessObjects.find(o => o.objectId == this.lastUserAddedToObject && o.email.trim().toLowerCase() == this.selectedAccessObject.email.trim().toLowerCase())!;
    this.lastAddedUser = foundObject.email;
    this.updateUser();

  }
  ngOnDestroy(): void {
    this.subscription.forEach((subs) => subs.unsubscribe());
  }

  accessAddTypeChange(event: any) {
    this.selectedAccessObject.accesId = event.value;

  }

  accessTypeChange(event: any) {
    this.accesssavebutton = true;
    this.changedAccessId = event.value;

    if (this.selectedAccessObject.accesId != this.changedAccessId) {
      this.accesssavebutton = false;

    }

  }
  @ViewChild(FlatBindingDirective) dataBinding!: FlatBindingDirective;

  public onFilter(value: string): void {
    const term = (value || "").trim().toLowerCase();

    // Optional: keep your width resizing logic
    const scalingFactor = 7;
    const newWidth = Math.max(50, term.length * scalingFactor);
    if (+this.width < 350) {
      if (newWidth - 100 > 0 && newWidth - 100 < 200) {
        this.width = (newWidth + 50).toString();
      }
    }

    // No filter -> restore full data
    if (!term) {
      this.displayObjects = [...this.accessObjects];
      this.expandedIds = [...this.allExpandableIds];
      return;
    }

    const data = this.accessObjects;

    // Helper: does a row match?
    const matches = (item: any) =>
      (item.name || "").toLowerCase().includes(term) ||
      (item.description || "").toLowerCase().includes(term);

    // Build lookup maps
    const byId = new Map<any, any>();
    const childrenByParent = new Map<any, any[]>();

    for (const item of data) {
      byId.set(item.id, item);

      const pid = item.objectId; // parentIdField
      if (pid !== null && pid !== undefined) {
        if (!childrenByParent.has(pid)) childrenByParent.set(pid, []);
        childrenByParent.get(pid)!.push(item);
      }
    }

    // Collect all ids we want to keep
    const keepIds = new Set<any>();

    const addAncestors = (item: any) => {
      let pid = item.objectId;
      while (pid !== null && pid !== undefined) {
        // Important: pid must be the actual parent "id" value (TreeList parentIdField must match idField)
        if (keepIds.has(pid)) break;
        keepIds.add(pid);

        const parent = byId.get(pid);
        if (!parent) break; // stop if parent not found
        pid = parent.objectId;
      }
    };

    const addDescendants = (parentId: any) => {
      const kids = childrenByParent.get(parentId) || [];
      for (const k of kids) {
        if (keepIds.has(k.id)) continue;
        keepIds.add(k.id);
        addDescendants(k.id);
      }
    };

    // Mark matches + their context
    for (const item of data) {
      if (matches(item)) {
        keepIds.add(item.id);

        // If a child matches -> keep ancestors (so parent shows)
        addAncestors(item);

        // If a parent matches -> keep all descendants
        addDescendants(item.id);
      }
    }

    // Apply filtered dataset
    this.displayObjects = data.filter(x => keepIds.has(x.id));

    // Expand parents that are in the result so children are visible
    const expanded = new Set<any>();
    for (const id of keepIds) {
      if (childrenByParent.has(id)) expanded.add(id);
    }
    this.expandedIds = Array.from(expanded);
  }

 
  onFilterUsers(event: Event) {
    
   /* if (this.isAutofill) {
      this.isAutofill = false; // reset flag
      return; // skip filtering
    }*/

    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    const scalingFactor = 7; // This value depends on the font size and family
    const characterCount = value.length;
    const newWidth = Math.max(50, characterCount * scalingFactor);
    if (+this.usersWidth < 400) {
      if (newWidth - 100 > 0 && newWidth - 100 < 200) {
        this.usersWidth = (newWidth + 50).toString();
      }
    }
    if (value.length) {
      this.displayUsers = this.initialUsers.filter(obj => obj.firstname?.toLowerCase().includes(value.toLowerCase()) || obj.lastname?.toLowerCase().includes(value.toLowerCase()) || obj.email?.trim().toLowerCase().includes(value.trim().toLowerCase()));
    } else {
      this.displayUsers = [...this.initialUsers];
      this.usersWidth = '200';
    }
    this.cdr.markForCheck();
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }
  public success(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 3000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "success", icon: true },
    });
  }
  getFileName() {
    let str = 'Portal Access';
    if (this.project?.projectnumber! != null) {
      console.log("this.project?.projectnumber",this.project?.projectnumber)
      return `${this.project.projectnumber}_${str} ${this.getFormattedDate()}.xlsx`;
    }
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  expandAll() {
    this.expandedIds = [...this.allExpandableIds];
  }

  collapseAll() {
    this.expandedIds = [];
  }


  public items: SpreadsheetMainMenuItem[] = [{ id: "file", active: true }];
  openedUploadWindow: boolean = false;
  @ViewChild('spreadsheet') spreadsheet1!: SpreadsheetComponent;
  windowTitle: string = 'Access Upload(s) Load';
  exceldata: SheetDescriptor[] = [
    {
      name: "Access",
      rows: [
        {
          cells: [
            {
              value: "Order Name",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Email",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Access",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            }
          ],
        },
        {
          cells: [{ value: "PO-101" },
          { value: "abc@mcdermott.com" },
          { value: "View" }],
        },
      ],
      columns: [
        { index: 0, width: 130 },
        { index: 1, width: 170 },
        { index: 2, width: 170 }
      ],
    },
  ];

  onUploadClick() {
    this.getAdminUsers();
    this.openedUploadWindow = true;
  }

  closeUploadWindow() {
    this.openedUploadWindow = false;
  }


  onExcelExport(e: any): void {
    const sheet = e.workbook.sheets[0];


    sheet.columns = [
      { width: 200 }, // Order Name
      { width: 250 }, // Order Description
      { width: 150 }, // First Name
      { width: 150 }, // Last Name
      { width: 220 }, // Email
      { width: 120 }, // Access
      { width: 150 }  // Upload Date
    ];

    // Clear default rows
    sheet.rows = [];

    // Add custom header
    sheet.rows.push({
      type: "header",
      cells: [
        { value: "Order Name" },
        { value: "Order Description" },
        { value: "First Name" },
        { value: "Last Name" },
        { value: "Email" },
        { value: "Access" },
        { value: "Assignment/Update Date" }
      ]
    });


    const sortedData = [...this.access].sort((a, b) =>
      (a.name || '').localeCompare(b.name || '')
    );


    // Add custom data rows
    sortedData.forEach(item => {
      if (item.objectId !== null) {
        sheet.rows.push({
          cells: [
            { value: item.name || "" },
            { value: item.description || "" },
            { value: item.firstname || "" },
            { value: item.lastname || "" },
            { value: item.email || "" },
            { value: item.accessName || "" },
            { value: item.uploadDate || "" }
          ]
        });
      }
    });

  }



  public onExcelExportInUpload(event: SpreadsheetExcelExportEvent): void {
    console.log(`excelExport`);
    console.log(event);
  }

  mySelection: number[] = [1];

  openedUploadwindow() {
    this.openedUploadWindow = true;

    setTimeout(() => {
      this.spreadsheet1.onMenuItemSelect("file");
    });
  }

  t!: SpreadsheetBackColorComponent;
  sheettrow!: SheetRow;
  cellStyle: CellDefaultStyle = {
    bold: true,
    underline: true,
    fontSize: 20,
    color: "#09a144",
  };
  headerValidation: boolean = false;
  spreadsheetObj!: SpreadsheetForeColorComponent;
  error!: string;
  value!: string;
  warning: { order: string; email: string; access: string }[] = [];
  diffCompanyWarningGridData: { order: string; email: string; access: string }[] = [];
  removalsWarning: { order: string; email: string }[] = [];
  uploadObjects: AccesObjects[] = [];
  removals: AccesObjects[] = [];
  uploadObject: AccesObjects = emptyAccessObjects();

  saveExcelSample(spreadsheet: SpreadsheetComponent): void {
    const data = spreadsheet.spreadsheetWidget.toJSON();
    this.uploadObjects = [];
    this.removals = [];
    const sheet = data.sheets;
    const rows = sheet![0].rows || [];
    this.error = '';
    this.warning = [];
    this.removalsWarning = [];
    this.diffCompanyWarningGridData = [];
    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].cells || [];

      if (i === 0) {
        this.headerValidation = this.validateHeader(rows[i]);
        if (!this.headerValidation) {
          this.error = 'Header validation failed.\n';
          break;
        }
        continue;
      }

      while (cells.length < 3) {
        cells.push({ value: '' });
      }

      const isEmptyRow = cells.every(cell => {
        const val = cell?.value?.toString().trim();
        return !val || val === '';
      });

      if (isEmptyRow) continue;

      let filledCount = 0;
      for (let j = 0; j < 3; j++) {
        const val = cells[j]?.value?.toString().trim();
        if (val && val !== '') {
          filledCount++;
        }
      }

      if (filledCount < 3) {
        this.error += `Row ${i}: not all fields have values (fieldcount ${filledCount})\n`;
        continue;
      }

      this.uploadObject = emptyAccessObjects();
      for (let j = 0; j < 3; j++) {
        const rawValue = cells[j]?.value?.toString().trim();
        const value = rawValue && rawValue !== '' ? rawValue : '-';
        this.validateUpload(value, j);
      }

      console.log("this.error",this.error)

      if (this.error.length > 0) {
        this.errorWindow = true;
        this.title = 'Error(s) - Access Upload';
        this.content = this.error;
        return;
      }

      if (!this.error) {
       // Case 1 Duplicate records
       console.log("this.displayObjects",this.displayObjects,this.uploadObject)
        const duplicate = this.displayObjects.find((obj) =>
          obj.email.trim().toLowerCase() === this.uploadObject.email.trim().toLowerCase() &&
          //obj.accesId === this.uploadObject.accesId &&
          obj.objectId === this.uploadObject.objectId &&
          obj.accesId != null && obj.accessName != ''
        );

        
        if (duplicate) {
            console.log("duplicate",duplicate)
            this.uploadObject.id = duplicate.id - 100000;

            if(this.uploadObject.accessName != 'Remove'){
              this.warning.push({
                order: this.uploadObject.name,
                email: this.uploadObject.email,
                access: duplicate.accessName
              });
            }
        }

        console.log("this.warning",this.warning)

        //Case 2 : Different company
        const user = this.adminUsers.find(x =>
        String(x?.email ?? '').trim().toLowerCase() === this.uploadObject.email.trim().toLowerCase()
        ) || {} as Users;

        console.log("this.uploadObject.company",this.uploadObject.company,user.companyName,user)
        if(this.uploadObject.company != user.companyName && (user.usertype == 'S' || user.usertype == 'X') ){

          this.diffCompanyWarningGridData.push({
                order: this.uploadObject.name,
                email: this.uploadObject.email,
                access: this.uploadObject.accessName
              });

        }



      }

       if(this.uploadObject.accessName == 'Remove'){
          const recordToRemove = this.displayObjects.find((obj) =>
            obj.email.trim().toLowerCase() === this.uploadObject.email.trim().toLowerCase() &&
            obj.objectId === this.uploadObject.objectId &&
            obj.accesId != null && obj.accessName != ''
          );
          if(recordToRemove){
            this.uploadObject.id = recordToRemove.id;
            this.removals.push(this.uploadObject);
          }
          
       } else {
          this.uploadObjects.push(this.uploadObject);
       }
    }

    

    // ✅ Handle warnings with QA-style dialog
    /*if (this.warning.length > 0) {
      console.log("this.uploadObjects------",this.uploadObjects)
      console.log("this.removals------",this.removals)
      this.warningGridData = this.warning; // Already structured with email, order, access

      const dialog: DialogRef = this.dialogService.open({
        title: 'Users Already Exist',
        content: this.userExistsDialog,
        actions: [
          { text: 'Cancel', themeColor: 'primary' },
          { text: 'Override', themeColor: 'primary' }
        ],
        width: 500,
        height: 300
      });

      dialog.result.subscribe((result: any) => {
        if (result.text === 'Override') {

          for (const obj of this.removals) {
            console.log("Objjjjjjjjjjjjjjjjjjjj",obj)
            this.removeAccessOfUserFromOrderExcel(obj); // implement this to delete by obj.id or (email, objectId)
          }

          this.overrideAccess();
        }
      });
      return;
    }





    const userCount = this.uploadObjects.length;
    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmation - Access Upload',
      content: this.dialogContentTemplate,
      //actions: [{ text: 'Cancel' }, { text: 'Add User' }, { text: 'Remove User' }],
      actions: [{ text: 'Cancel' }, { text: 'Save' }],
      width: 450,
      height: 250
    });


    console.log("this.uploadObjects------",this.uploadObjects)
    dialog.result.subscribe((result: any) => {
      if (result.text === 'Cancel') {
        dialog.close();
      }
      if (result.text === 'Save') {

        
        for (const obj of this.removals) {
          const cleanObj = { ...obj };
          if (cleanObj.name) cleanObj.name = cleanObj.name.replace(/,/g, '');
          this.removeAccessOfUserFromOrderExcel(cleanObj);
        }


        for (const obj of this.uploadObjects) {
          const cleanObj = { ...obj };
          if (cleanObj.name) {
            cleanObj.name = cleanObj.name.replace(/,/g, '');
          }
          if (obj.id > 0) {
            this.updateAccess(cleanObj);
          } else {
            this.addAccess(cleanObj);
          }
        }
        this.closeUploadWindow();
      }
    });*/


  // 2. COMPANY WARNING (FIRST)
  if (this.diffCompanyWarningGridData.length > 0) {

    const dialog: DialogRef = this.dialogService.open({
      title: 'Company Mismatch Warning',
      content: this.companyDifferentDialougue,
      actions: [
        { text: 'Cancel' },
        { text: 'Continue', themeColor: 'primary' }
      ],
      width: 550,
      height: 350
    });

    dialog.result.subscribe((result: any) => {

      if (result.text === 'Cancel') return;

      if (result.text === 'Continue') {

        // Check duplicate warning AFTER company warning
        if (this.warning.length > 0) {

          this.warningGridData = this.warning;

          const dupDialog: DialogRef = this.dialogService.open({
            title: 'Users Already Exist',
            content: this.userExistsDialog,
            actions: [
              { text: 'Cancel' },
              { text: 'Override', themeColor: 'primary' }
            ],
            width: 500,
            height: 300
          });

          dupDialog.result.subscribe((dupResult: any) => {

            if (dupResult.text === 'Override') {

              // IMPORTANT: original override logic
              for (const obj of this.removals) {
                this.removeAccessOfUserFromOrderExcel(obj);
              }

              this.overrideAccess(); //  NO Save dialog after this
            }
          });

        } else {
          //  No duplicate warning → go normal save flow
          this.openSaveDialog();
        }
      }
    });

    return;
  }

  //  3. DUPLICATE WARNING ONLY
  if (this.warning.length > 0) {

    this.warningGridData = this.warning;

    const dialog: DialogRef = this.dialogService.open({
      title: 'Users Already Exist',
      content: this.userExistsDialog,
      actions: [
        { text: 'Cancel' },
        { text: 'Override', themeColor: 'primary' }
      ],
      width: 500,
      height: 300
    });

    dialog.result.subscribe((result: any) => {

      if (result.text === 'Override') {

        //  original logic
        for (const obj of this.removals) {
          this.removeAccessOfUserFromOrderExcel(obj);
        }

        this.overrideAccess(); //  NO Save dialog here
      }
    });

    return;
  }

  //  4. NORMAL CASE (NO WARNINGS, NO ERRORS)
  this.openSaveDialog();

    
  }

  openSaveDialog() {

    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmation - Access Upload',
      content: this.dialogContentTemplate,
      actions: [{ text: 'Cancel' }, { text: 'Save' }],
      width: 450,
      height: 250
    });

    dialog.result.subscribe((result: any) => {

      if (result.text === 'Cancel') return;

      if (result.text === 'Save') {

        for (const obj of this.removals) {
          const cleanObj = { ...obj };
          if (cleanObj.name) cleanObj.name = cleanObj.name.replace(/,/g, '');
          this.removeAccessOfUserFromOrderExcel(cleanObj);
        }

        for (const obj of this.uploadObjects) {
          const cleanObj = { ...obj };
          if (cleanObj.name) {
            cleanObj.name = cleanObj.name.replace(/,/g, '');
          }

          if (obj.id > 0) {
            this.updateAccess(cleanObj);
          } else {
            this.addAccess(cleanObj);
          }
        }

        this.closeUploadWindow();
      }
    });
  }

  overrideAccess() {
    for (const obj of this.uploadObjects) {
      this.updateAccess(obj);
    }
    this.closeUploadWindow();
  }


  public get formattedErrorText(): string {
    return this.content
      .split('\n')
      .map(line =>
        line
          .split(':')
          .map(part => part.trim())
          .join('\t')
      )
      .join('\n');
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedErrorText).then(() => {
      console.log('Copied to clipboard');
    });
  }


  validateHeader(value: any): boolean {

    let checkvalue: boolean = true;

    if (value.cells![0].value!.valueOf().toLocaleString().toUpperCase() != 'ORDER NAME') {
      checkvalue = false;

    }
    if (value.cells![1].value!.valueOf().toLocaleString().toUpperCase() != 'EMAIL') {
      checkvalue = false;
    }

    if (value.cells![2].value!.valueOf().toLocaleString().toUpperCase() != 'ACCESS') {
      checkvalue = false;
    }

    if (!checkvalue) {
      this.error = 'Wrong Temoplate Header. must contain [Order Name,	Email, Access]'
    }
    return checkvalue;
  }

  validateUpload(value: string, field: number) {

    const rawValue = value ?? '';
    const trimmedValue = rawValue.trim();
    

    if (field == 0) {
      const matchedObject = this.adminObjects.find((x) => x.name === trimmedValue);
      //console.log("value",trimmedValue,"this.adminObjects", this.adminObjects,"matchedObject",matchedObject)
      if (!matchedObject) {
        this.error = this.error + 'Invalid Order: ' + trimmedValue + '\n';
      } else {
        console.log("matchedObject", matchedObject)
        this.uploadObject.name = matchedObject.name;
        this.uploadObject.description = matchedObject.description;
        this.uploadObject.objectId = matchedObject.id;
        this.uploadObject.company = matchedObject.companyName;
      }
    }

    if (field == 1) {
      //console.log("this.adminUsers", this.adminUsers,"value",trimmedValue)
      const targetEmail = trimmedValue.toLowerCase();
      
      /*this.userObjValidate = this.adminUsers.find(x =>
            String(x?.email ?? '').trim().toLowerCase() === targetEmail
          );*/

      
      this.userObjValidate = this.adminUsers.find(x =>
        String(x?.email ?? '').trim().toLowerCase() === targetEmail.trim().toLowerCase()
      );




      //const userObject = this.adminUsers.find((x) => x.email.toLowerCase == trimmedValue.toLowerCase);
      console.log("userObject", this.userObjValidate)
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        this.error += 'Invalid email address: ' + value + '\n';
      } else if (!this.userObjValidate) {
        this.error = this.error + 'Invalid User: ' + value + '\n';
      } else if (this.userObjValidate && this.userObjValidate.enabled=='F') {
        this.error = this.error + 'User is Disabled: ' + value + '\n';
      } else {
        this.uploadObject.email = this.userObjValidate.email;
        this.uploadObject.firstname = this.userObjValidate.firstname;
        this.uploadObject.lastname = this.userObjValidate.lastname;
        this.uploadObject.enabled = this.userObjValidate.enabled;
      }

    }
    if (field == 2) {
       console.log("value", trimmedValue)
       
      const targetAccess = trimmedValue.toUpperCase();
      const accessTypeObj = this.accessItems.find(
        x => String(x?.text ?? '').trim().toUpperCase() === targetAccess
      );

      //let accessTypeObj = this.accessItems.find(x => x.text.toUpperCase() === trimmedValue.toUpperCase());
      console.log("accessTypeObj", accessTypeObj,this.userObjValidate)
      if (!accessTypeObj) {
        this.error = this.error + 'Invalid Access Type: ' + value + '\n';
      } else if(this.userObjValidate && (this.userObjValidate.usertype == 'S' || this.userObjValidate.usertype == 'X') && targetAccess!= 'UPLOAD'){
        this.error = this.error + 'Users with a supplier role should only have access to the upload function: ' + 'Entry : '+this.userObjValidate.email +' '+ value + '\n';
      } else {
        this.uploadObject.accesId = accessTypeObj.value;
        this.uploadObject.accessName = accessTypeObj.text;
        this.uploadObject.id = 0;
      }
    }
    console.log("success")
  }

  addAccess(obj: any) {
    this.portalAdminService.addObjectAccess(this.selectedProjectId, obj).subscribe({
      next: (result) => {
        this.selectedAccessObject = result;
        this.newUserAdded = true;
        this.cdr.markForCheck();

      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);
        this.selected = [];

      }
    });
  }

  updateAccess(obj: any) {
    this.loading = true;
    /*100000 used for making the id Unque*/


    this.portalAdminService.updateObjectAccess(this.selectedProjectId, obj.id, obj).subscribe({
      next: (result) => {
        this.selectedAccessObject = result;
        this.selectedAccessObject.id = obj.id + 100000;
        this.selectedAccessObject.email = this.selection[0];
        this.lastUserAddedToObject = this.selectedAccessObject.objectId;
        this.userUpdated = true;
        this.cellHeight = document.querySelector(".k-table-td")?.clientHeight;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      },
      complete: () => {

        this.loading = false;
        this.handleLoad(this.selectedProjectId);

        this.openedaccesswindow = false;
        this.selected = [];
        this.accesssavebutton = true;


      }
    });
  }

}
